let list = []

list.push({
  name: "com-style1",
  path: () => import("./style1.vue"),
});
list.push({
  name: "com-style2",
  path: () => import("./style2.vue"),
});
list.push({
  name: "com-icon",
  path: () => import("./icon"),
});
list.push({
  name: "com-alert",
  path: () => import("./alert.vue"),
});
list.push({
  name: "com-echarts",
  path: () => import("../common/echart"),
});
export default (Vue) => {
  list.map((item) => {
    Vue.component(item.name, item.path);
  });
};


// WEBPACK FOOTER //
// ./src/components/index.js